/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import logo from './img/logo.png';
import LoginForm from './LoginForm';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('es');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.title = 'TELESPECTACULO';
  }

  render() {
    const { translate } = this.props;

    return (
      <Container fluid={true} className="telesp-body">
        <Row style={{ marginTop: '40px' }}>
          <Col sm='12' lg='10' md='10'>
            <Row>
              <Col sm='12' lg='8' md='8'>
                <img src={logo} alt="logo" className="logo-telesp rounded mx-auto d-block" />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{ backgroundColor: '#F6F1EE' }}>
          <Col sm='12' lg='10' md='10'>
            {
              this._validateParams()
                ? <LoginForm
                  api={this.api}
                  location={this.props.location}
                />
                : <RequestLoginErrorMessage
                  onlyMessage={true}
                  message={translate('RequestLoginErrorMessage')}
                />
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

export default WithLocalize(Login);
